//-----------------------------------
// ### Theme asset paths ###
//-----------------------------------
//
// Every frontend is deployed with its own asset directory only (/js/<theme>, /css/<theme>);
// the other themes are stripped from the build. Dynamically loaded assets must therefore never
// use a hardcoded theme path, otherwise they 404 on every shop but the hardcoded one.
//
// Note: $.cachedScript() in main.js rewrites a hardcoded /js/aponeo_de/ prefix to the current
// shop, which used to hide this for scripts - but $.loadStylesheet() has no such rewrite, so
// hardcoded stylesheets stayed broken. Resolve the theme here instead of relying on that.
//
// The theme is derived from the URL of the bundle that is currently being executed,
// e.g. /js/pharmeo_de/min/dist/main.js -> pharmeo_de.

const FALLBACK_THEME = 'aponeo_de';

// Matches the theme segment of a webpack bundle URL (js/<theme>/[min/]dist|bundles/<file>)
const THEME_PATTERN = /\/js\/([^/]+)\/(?:min\/)?(?:dist|bundles)\//;

const detectTheme = () => {
  // The bundle importing this module is evaluated synchronously while its own script tag runs,
  // so currentScript points at that bundle.
  const currentScript = document.currentScript;
  const currentMatch = currentScript && THEME_PATTERN.exec(currentScript.src || '');

  if (currentMatch) {
    return currentMatch[1];
  }

  // Fallback for cases where currentScript is unavailable (e.g. the bundle was injected
  // by a script loader): look the bundle up in the DOM instead.
  const scripts = document.getElementsByTagName('script');

  for (let i = 0; i < scripts.length; i += 1) {
    const match = THEME_PATTERN.exec(scripts[i].src || '');

    if (match) {
      return match[1];
    }
  }

  return FALLBACK_THEME;
};

const theme = detectTheme();

/**
 * URL of a minified asset of the current theme.
 *
 * @param {string} type Asset type directory, 'js' or 'css'
 * @param {string} file Path of the asset relative to the theme's min directory
 * @returns {string}
 */
export const themeAssetUrl = (type, file) => `/${type}/${theme}/min/${file}`;
